import { DependenciesInjection } from "app/di/DependencyInjection";
import { ISimLookupRepository } from "../domain/repositories/ISimLookupRepository";
import { SimLookupUseCase } from "../domain/useCases/SimLookupUseCase";
import { SimLookupToken } from "./SimLookupToken";
import { SimLookupImpl } from "../data/SimLookupImpl";
import { SimLookupViewModel } from "../presentation/viewModel/SimLookupViewModel";

export class SimLookupInjection {
  static initInjections() {
    DependenciesInjection.register<ISimLookupRepository>(
      SimLookupToken.ISimLookupRepository,
      SimLookupImpl,
      "otherRepo",
    );
    DependenciesInjection.register<SimLookupUseCase>(
      SimLookupToken.SimLookupUseCase,
      SimLookupUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<SimLookupViewModel>(
      SimLookupToken.SimLookupViewModel,
      SimLookupViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<ISimLookupRepository>(
      SimLookupToken.ISimLookupRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<SimLookupUseCase>(
      SimLookupToken.SimLookupUseCase,
    );
  }

  static getViewModel() {
    return DependenciesInjection.getRepo<SimLookupViewModel>(
      SimLookupToken.SimLookupViewModel,
    );
  }
}
